<template>
	<div 
		class="uploading-row"
		:class="[
			status == 'success' ? 'complete' : '',
			status == 'error' ? 'error' : '',
			status == 'canceled' ? 'cancelled' : '',
			status == 'pending' ? 'pending' : '',
			`theme-${theme}`
		]"
		>

		<div class="info-bar">
			<div class="left-side">
				<div class="icon">
					<i class="fal fa-file" />
				</div>
				<div class="file-info">
					<div class="file-name">
						{{ file.fileName }} 
					</div>
					<div class="file-size" v-if="status == 'uploading' || status == 'success'">
						{{ humanFileSize(size) }}
					</div>
				</div>
			</div>
			<div class="right-side">
				<div class="success" v-if="status == 'success'">
					<img src="/images/icons/check-circle.svg" />
				</div>
				<div class="percentage" v-if="status != 'success' && status != 'pending' && status != 'canceled' && status != 'error'">
					{{ Math.floor(uploadedAmount) }}%
				</div>
				<div class="file-status pending" v-if="status == 'pending'">
					Pending upload
				</div>
				<div class="file-status cancelled" v-if="status == 'canceled'">
					Cancelled
				</div>
				<div class="file-status error" v-if="status == 'error'">
					Error
				</div>
				<div class="control" v-if="status != 'success'">
					<span v-if="isUploading">
						<button @click="cancel()">cancel</button>
					</span>
				</div>
			</div>
		</div>

		<div 
			class="progress-track"
			:class="[
				status == 'success' ? 'complete' : '',
				status == 'retrying' ? 'retrying' : '',
				status == 'error' ? 'error' : '',
				status == 'canceled' ? 'cancelled' : '',
				isPaused ? 'paused' : '',
			]"
			>
			<div class="progress-bar" :style="{ width: `${uploadedAmount}%` }" />
		</div>
		

	</div>
</template>

<script>
export default {
		props: [
			'file',
			'status',
			'progress',
			'size',
			'theme'
		],
		data(){
			return {
				isPaused: false // we upload straight away by default
			}
		},
		mounted(){
			// console.log('file row added', {
			// 	status: this.status
			// })
		},
		computed: {
			isUploading(){
				return (this.status !=='success' && this.status !== 'canceled')
			},
			uploadedAmount(){
				return (this.progress * 100).toFixed(2)
			},
		},
		methods: {
			upload(){
				this.file.resumableObj.upload()
				this.isPaused = false
			},
			pause(){
				this.file.pause()
				this.isPaused = true
			},
			resume(){
				this.pause() // not sure why, but we have to call pause again before upload will resume
				this.upload()
			},
			cancel(){
				this.$emit('cancel', this.file)
			},
			humanFileSize(payload) {
				let fileSize = ''
				let size = parseInt(payload)

				if (size >= 1073741824) {
					fileSize = this.round(size / 1024 / 1024 / 1024, 1) + ' GB'
				} else if (size >= 1048576) {
					fileSize = this.round(size / 1024 / 1024, 1) + ' MB'
				} else if(size >= 1024) {
					fileSize = this.round(size / 1024, 1) + ' KB'
				} else {
					fileSize = size + ' bytes'
				}
				return fileSize
			},
			round(value, precision) {
				let multiplier = Math.pow(10, precision || 0);
				return Math.round(value * multiplier) / multiplier;
			}
		}
}
</script>

<style scoped lang="sass">
.uploading-row
	width: 100%
	margin-bottom: 20px
	padding: 10px
	border-radius: 3px
	
	.info-bar
		display: flex
		justify-content: space-between
		align-items: center
		width: 100%

		.left-side
			display: flex
			align-items: center

			.icon
				width: 40px
				height: 40px
				margin-right: 20px
				display: flex
				align-items: center
				
				.fal
					color: #222
					font-size: 40px

			.file-info
				display: flex
				flex-direction: column

				.file-size
					font-weight: 700
					text-align: left

		.right-side
			display: flex
			text-align: right
			justify-content: flex-end
			flex-direction: column

			.success
				width: 40px
				height: 40px

				img
					max-height: 40px
					width: 100%
					height: auto

			.percentage
				font-weight: 700

			.file-status
				font-weight: 700
				font-size: 14px
				text-transform: uppercase

				&.pending
					color: #ff9000

				&.cancelled
					color: #f00
				
				&.error
					color: #f00

			.control
				button
					margin-left: 15px
					font-size: 12px
					text-transform: uppercase

	.progress-track
		height: 16px
		background-color: #d7d7d7
		border-radius: 6px
		overflow: hidden
		width: 100%
		margin-top: 15px

		.progress-bar
			background-color: #70C2FF
			height: 16px
			border-radius: 6px
			transition: all 300ms

		&.complete
			.progress-bar
				background-color: #5AAE4B
		
		&.paused
			.progress-bar
				background-color: #666

		&.error, &.cancelled
			.progress-bar
				background-color: #f00

	&.pending
		background-color: rgba(#ff9000, 0.1)

		.progress-track
			display: none

	&.cancelled
		background-color: rgba(#f00, 0.1)

		.progress-track
			display: none
	
	&.error
		background-color: rgba(#f00, 0.1)

		.progress-track
			display: none

	&.theme-dark
		color: #f8f8f8

		.info-bar
			.left-side
				.icon
					.fal
						color: #f8f8f8

		&.pending
			background-color: rgba(#ff9000, 0.2)

		&.cancelled
			background-color: rgba(#f00, 0.1)
		
		&.error
			background-color: rgba(#f00, 0.1)


</style>